import { AuthContextService } from '@/services';
import { AccountApi, BillingApi } from '@/types';
import { CalculatedPrice, PriceHelperNew } from './product-price-new-helper';
import { RenewPriceInfo } from '@/atomic-components/organisms/forms/edit-forms/ssl/ssl-certificate-edit-callcenter';
import { ContractPeriodWord } from '@/configuration';

export interface ProductPriceParams {
    productCode: string,
    accountId: string
}

export type ProductPriceNewRequests = {
    getPriceFromProductCode: (params: ProductPriceParams) => Promise<BillingApi.ArticlePurchasePrice[]>
}

export class ProductPriceNew {

    public account: AccountApi.Account | AccountApi.Subaccount;
    public state: 'loaded' | 'loading' | 'unknown';

    private _priceResponse: BillingApi.ArticlePurchasePrice[];

    constructor(
        private requests: ProductPriceNewRequests,
    ) {
        this.account = AuthContextService.account;
    }

    public getProductPrice = (productCode: string): RenewPriceInfo => {
        if (this.state === 'loaded') {
             // hier könnte ein $timeout hin, falls was nicht klappt (war vorher)
            const calculatedPrice = this._calculatePrice(this._priceResponse[0]);
            if (!('price' in calculatedPrice)) {
                return { state: 'unknown' };
            }
            return {
                state: 'loaded',
                amountScaled10000: calculatedPrice.price,
                currency: calculatedPrice.currency,
                billingPeriod: this._priceResponse[0].contractPeriod as ContractPeriodWord
            };
        }

        if (this.state === 'unknown') {
            return { state: 'unknown' };
        }

        this.state = 'loading';
        const subAccount = AuthContextService?.account?.id !== this.account?.id
            ? this.account?.id
            : null;
        this.requests.getPriceFromProductCode(
            {
                productCode: productCode,
                accountId: subAccount
            }
        ).then(
            (result: BillingApi.ArticlePurchasePrice[]) => {
                this._priceResponse = result;
                this.state = 'loaded';
            }
        );
    }

    private _calculatePrice = (priceObject: BillingApi.ArticlePurchasePrice): CalculatedPrice => {
        const showPromotionPrice = [undefined, null].indexOf(priceObject.promotionalNetAmount) < 0;

        const calculatedPrice = PriceHelperNew.calculatePrice(
            priceObject,
            this.account.isCommercialCustomer,
            showPromotionPrice,
        );
        if (!('price' in calculatedPrice)) {
            this.state = 'unknown';
            return calculatedPrice;
        }

        this.state = 'loaded';
        return calculatedPrice;
    }
}
